module.exports = __webpack_public_path__ + "img/ecosystem_img.b291aeda.gif";